import { Directive, ElementRef, HostListener, Renderer2, Input, ViewContainerRef, TemplateRef, ViewChild, ViewRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TableRenderService } from './table-render.service';

@Directive({
  selector: '[st-row]'
})
export class RowsRenderDirective {

  @Input('st-row') id: string;

  @Input() type: 'title';
  constructor(private renderService:TableRenderService,private ref: TemplateRef<void>) {

  }

  ngOnInit(): void {
    this.renderService.add(this.type, this.id, this.ref);
  }
}
